import * as Yup from "yup";

export const createSubscriptionInitialValues = {
  code: "",
  addOns: [],
  paymentMethodId: undefined,
  planId: undefined,
  priceId: undefined,
};

export type CreateSubscriptionValues = typeof createSubscriptionInitialValues;

export const createSubscriptionValidationSchema = Yup.object().shape({
  planId: Yup.string().required(),
  priceId: Yup.string().required("Price ID is required"),
  paymentMethodId: Yup.string().optional(),
  addOns: Yup.array().of(Yup.string()),
});
